import React from "react";

const BrandSection = () => (
  <div className="login-brand-content">
    <div className="login-brand-fade">
      <div className="login-logo-ring">
        <div className="login-logo-glow" aria-hidden="true" />
        <img
          src={`${process.env.PUBLIC_URL}/assets/img/logo.png`}
          alt="Aptitude Migration"
          width={88}
          height="auto"
          className="login-brand-logo"
        />
      </div>

      <h1 className="login-brand-title">Aptitude Migration</h1>

    

      <div className="login-brand-divider" />

      <p className="login-brand-mission text-green-300">&ldquo;Vision to Succeed.&rdquo;</p>
    </div>
  </div>
);

export default BrandSection;
